module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_78.85579fb5.jpg";